import React from 'react'

const IFrameContainer = () => {
  return (
    <>
      <div id="iframe-container">

      </div>
    </>
  )
}

export default IFrameContainer